import React from 'react';
import css from "./SecFour.module.scss";
import {Link} from "react-router-dom";
import {PORTFOLIO} from "../../../../Utils/Urls";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {useTranslation} from "react-i18next";

const SecFour = () => {

    const {t} = useTranslation();

    return (
        <section className={css.four}>
            <Link
                to={PORTFOLIO + "/photo"}
            >
                {t("portfolio")} <ArrowOutwardIcon/>
            </Link>
        </section>
    );
};

export default SecFour;